import template from './homeLoanPreferredProductSummary.template.html';

export default {
  template,
  bindings: {
    lender: '<',
    lenderLogo: '<',
    reviewProducts: '<',
    switchProducts: '<',
    preferredProduct: '<',
    idTicket: '<',
    allowChanges: '<',
    allowSwitch: '<',
    isTicketSettled: '<',
    onChange: '&',
    onSwitch: '&',
    onSwitchFinished: '&'
  },
  controller: class controller {
    constructor($rootScope, $mdDialog, $mdMedia, helperService) {
      'ngInject';

      const ctrl = this;
      ctrl.$mdMedia = $mdMedia;
      ctrl.currentOrganization = $rootScope.CurrentOrganization;
      ctrl.currentCurrency = $rootScope.CurrentCurrency();
      ctrl.currentTimeZone = $rootScope.CurrentTimeZone();
      ctrl.currentDateFormat = $rootScope.CurrentDateFormatPrimary();
      ctrl.organizationCountry = helperService.getOrganizationCountry();
      ctrl.isReady = false;

      ctrl.initialize = () => {
        ctrl.lender = ctrl.lender || {};
        ctrl.lenderLogo = ctrl.lenderLogo || '';
        ctrl.reviewProducts = ctrl.reviewProducts || [];
        ctrl.switchProducts = ctrl.switchProducts || [];
        ctrl.preferredProduct = ctrl.preferredProduct || null;
        ctrl.allowChanges = ctrl.allowChanges || false;
        ctrl.allowSwitch = ctrl.allowSwitch || false;
        ctrl.isTicketSettled = ctrl.isTicketSettled || false;
        ctrl.switchedProducts = [];
        const len = ctrl.preferredProduct?.productSplits?.length || 0;
        for (let i = 0; i < len; i += 1) {
          const productSplit = ctrl.preferredProduct.productSplits[i];
          if (productSplit?.idParent) {
            ctrl.setSwitchedProducts({ idParent: productSplit.idParent, idx: i });
          }
        }
        ctrl.isReady = true;
      };

      ctrl.setSwitchedProducts = ({ idParent, idx }) => {
        const switchedCompareProduct = _.find(
          _.flatten(
            _.map(
              _.filter(ctrl.switchProducts?.switchCompareProducts, (s) => !s.isActive),
              'productSplits'
            )
          ),
          (p) => p?.id === idParent
        );
        if (switchedCompareProduct) {
          if (!ctrl.switchedProducts[idx]?.length) {
            ctrl.switchedProducts[idx] = [];
          }
          ctrl.switchedProducts[idx].push(switchedCompareProduct);
          if (switchedCompareProduct?.idParent) {
            ctrl.setSwitchedProducts({ idParent: switchedCompareProduct.idParent, idx });
          }
        }
      };

      ctrl.getProduct = (idLender, idx) => {
        const selectedProduct = _.find(ctrl.reviewProducts, (p) => p.idLender === idLender);
        if (selectedProduct) {
          return selectedProduct.productSplits[idx];
        }
        return selectedProduct;
      };

      ctrl.getSwitchReviewProduct = ({ idParent, idProduct, isActive }) => {
        const idx = _.findIndex(ctrl.allSwitchProducts({ isActive }), (p) =>
          idParent ? p.idParent === idParent : p.idProduct === idProduct
        );
        const selectedProduct = _.flatten(
          _.map(
            _.filter(ctrl.switchProducts?.switchReviewProducts, (p) => p.isActive === isActive),
            'productSplits'
          )
        );
        return idx > -1 && selectedProduct ? selectedProduct[idx] : undefined;
      };

      ctrl.getSwitchedDate = ({ id }) => {
        const archivedSwitchProducts = _.filter(
          ctrl.switchProducts?.switchCompareProducts,
          (p) => !p.isActive
        );
        let switchedDate = 0;
        for (let i = 0; i < archivedSwitchProducts.length; i += 1) {
          const archivedSwitchProduct = archivedSwitchProducts[i];
          const productSplit = _.find(
            archivedSwitchProduct?.productSplits,
            (p) => p?.id === id
          );
          if (productSplit) {
            switchedDate = moment
              .utc(archivedSwitchProduct?.switchTimeStamp, 'X')
              .tz(ctrl.currentTimeZone || 'UTC')
              .format(ctrl.currentDateFormat || 'LL');
          }
        }
        return switchedDate;
      };

      ctrl.allSwitchProducts = ({ isActive }) =>
        _.flatten(
          _.map(
            _.filter(
              ctrl.switchProducts?.switchCompareProducts,
              (p) => p.isActive === isActive
            ),
            'productSplits'
          )
        );

      ctrl.getSwitchProductSplit = ({ idParent }) =>
        _.find(ctrl.allSwitchProducts({ isActive: true }), (p) => p?.idParent === idParent);

      ctrl.anySwitchProductSplits = () => {
        const productSplits = _.map(ctrl.preferredProduct.productSplits, 'id');
        const switchSplits = _.map(ctrl.allSwitchProducts({ isActive: true }), 'idParent');
        const inter = _.intersection(productSplits, switchSplits);
        return inter && inter.length;
      };

      ctrl.removeSwitchProductSplit = ({ idParent }) => {
        const parentProduct = ctrl.getSwitchProductSplit({ idParent });
        const removeProductSplit = (productSplit, idProduct) => {
          const product = productSplit;
          if (product.isActive) {
            product.productSplits = _.reject(
              product.productSplits,
              (p) => p?.idProduct === idProduct
            );
            if (!product.productSplits.length) {
              ctrl.switchProducts.switchReviewProducts = _.reject(
                ctrl.switchProducts.switchReviewProducts,
                (p) => p?.id === product.id
              );
            }
          }
        };
        if (parentProduct) {
          const { idProduct } = parentProduct;
          _.forEach(ctrl.switchProducts?.switchReviewProducts, (sp) => {
            removeProductSplit(sp, idProduct);
          });
          _.forEach(ctrl.switchProducts?.switchCompareProducts, (sp) => {
            removeProductSplit(sp, idProduct);
          });
          ctrl.onSwitchFinished({ switchProducts: ctrl.switchProducts });
        }
      };

      ctrl.switchReviewProductChanges = () => {
        ctrl.onSwitchFinished({ switchProducts: ctrl.switchProducts });
      };

      ctrl.$onInit = () => {
        ctrl.initialize();
      };
    }
  }
};
